import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Button, CircularProgress } from '@material-ui/core';

import '../assets/stylesheets/EmployeeAttributes.css';
import i18n from '../i18n';

class SaveCancelContainer extends Component {
  render() {
    const { onSave, onCancel, saving } = this.props;
    return (
      <Grid container className="saveCancelContainer">
        {saving ? (
          <Grid item xs={2}>
            <CircularProgress color="secondary" />
            <span>{i18n.t('saving')}</span>
          </Grid>
        ) : (
          <>
            <Grid item xs={2}>
              <Button
                variant="contained"
                className="ssenseButton ssenseSecondary"
                onClick={onSave}
              >
                {i18n.t('save')}
              </Button>
            </Grid>
            <Grid item xs={2}>
              <Button
                variant="contained"
                className="ssenseButton ssensePrimary"
                onClick={onCancel}
              >
                {i18n.t('cancel')}
              </Button>
            </Grid>
          </>
        )}
      </Grid>
    );
  }
}

SaveCancelContainer.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
}

export default SaveCancelContainer;
